import { useQuery } from '@tanstack/react-query';
import type { SlateGame } from '@/app/api/slate/route';

interface SlateResponse {
  games: SlateGame[];
}

async function fetchSlate(): Promise<SlateResponse> {
  const response = await fetch('/api/slate');
  if (!response.ok) {
    throw new Error(`Failed to fetch slate: ${response.statusText}`);
  }
  return response.json();
}

export function useSlateData(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['slate'] as const,
    queryFn: fetchSlate,
    staleTime: 30 * 1000,
    gcTime: 15 * 60 * 1000,
    retry: 2,
    enabled: options?.enabled ?? true,
  });
}
